import { Alert, AlertTitle, Typography } from '@mui/material';
import { formatNumber, NumberFormatPreset, useCurrency, formatDate, DateFormatPreset } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';

import { agreementStatus, DetailStatusProps } from '../NegotiationCaseDetailStatusWidget.types';
import { I18nNamespace } from '~/common/types';

const formatPercent = formatNumber(NumberFormatPreset.PERCENT_DECIMAL);

export const AgreementStatus = ({ isMasked, negotiationCaseStatus, negotiatedQuote }: DetailStatusProps) => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'NegotiationCaseDetailStatusWidget' });
  const { format: formatCurrency } = useCurrency();

  const discountPercentage: string = negotiatedQuote ? formatPercent((negotiatedQuote.discount as number) ?? 0) : '';

  // Due to the insert only logic the creation date is the negotiation date
  const negotiatedAt = negotiatedQuote ? new Date(negotiatedQuote.createdAt) : null;

  if (agreementStatus.includes(negotiationCaseStatus)) {
    return (
      <Alert severity="success">
        <AlertTitle>
          {t('agreement.title', {
            createdAt: negotiatedAt ? formatDate(DateFormatPreset.TWO_DIGIT, negotiatedAt) : null,
          })}
        </AlertTitle>
        {isMasked ? null : (
          <>
            <Typography variant="body2">
              {t('agreement.initialPrice', {
                price: formatCurrency(negotiatedQuote?.totalValue || 0),
              })}
            </Typography>
            <Typography variant="body2">
              {t('agreement.negotiatedPrice', {
                price: formatCurrency(negotiatedQuote?.totalDiscountedValue || 0),
              })}{' '}
            </Typography>
            <Typography variant="body2">{t('agreement.discountPercentage', { discountPercentage })}</Typography>
            <Typography variant="body2">
              {t('agreement.discountValue', {
                price: formatCurrency(negotiatedQuote?.totalPriceDiscount || 0),
              })}
            </Typography>
          </>
        )}
      </Alert>
    );
  }

  return null;
};
